export const URL_Screens = (`${process.env.REACT_APP_HOST}/screens`)